import { render } from "./Mobile.vue?vue&type=template&id=1474ff70&lang=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/AssistantAi/StartUpIcons/Mobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1474ff70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1474ff70', __exports__)) {
    api.reload('1474ff70', __exports__)
  }
  
  module.hot.accept("./Mobile.vue?vue&type=template&id=1474ff70&lang=true", () => {
    api.rerender('1474ff70', render)
  })

}


export default __exports__